// src/admin/ManageEvents.js

import React, { useState, useEffect } from 'react';
import { db } from '../config/firebaseConfig';
import { collection, getDocs, doc, deleteDoc } from 'firebase/firestore';
import EditEventModal from './EditEventModal'; // We will create this component next

const ManageEvents = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // State for the modal
  const [showModal, setShowModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);

  // Fetch events from Firestore
  const fetchEvents = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, 'events'));
      const eventsList = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setEvents(eventsList);
    } catch (err) {
      console.error("Error fetching events: ", err);
      setError('Failed to load events. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  // Run fetchEvents on component mount
  useEffect(() => {
    fetchEvents();
  }, []);

  // Handle opening the edit modal
  const handleEdit = (event) => {
    setSelectedEvent(event);
    setShowModal(true);
  };

  // Handle closing the modal
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedEvent(null);
  };
  
  // This function will be called from the modal to update the list in real-time
  const handleEventUpdated = (updatedEvent) => {
    setEvents(events.map(event => event.id === updatedEvent.id ? updatedEvent : event));
    fetchEvents(); // Or refetch all events to ensure consistency
  };

  // Handle event deletion
  const handleDelete = async (eventId) => {
    if (window.confirm('Are you sure you want to delete this event? This action cannot be undone.')) {
      try {
        await deleteDoc(doc(db, 'events', eventId));
        // Remove the event from the local state to update the UI instantly
        setEvents(events.filter(event => event.id !== eventId));
        alert('Event deleted successfully!');
      } catch (err) {
        console.error("Error deleting event: ", err);
        alert('Failed to delete event.');
      }
    }
  };

  if (loading) {
    return <div className="container mt-5 text-center">Loading events...</div>;
  }

  if (error) {
    return <div className="container mt-5 alert alert-danger">{error}</div>;
  }

  return (
    <div className="container mt-5">
      <h2>Manage Events</h2>
      <p>Here you can view, edit, or delete existing events.</p>
      
      {events.length === 0 ? (
        <p>No events found.</p>
      ) : (
        <div className="table-responsive">
          <table className="table table-striped table-hover">
            <thead className="thead-dark">
              <tr>
                <th>Poster</th>
                <th>Event Name</th>
                <th>Location</th>
                <th>Date</th>
                <th>Time</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {events.map((event) => (
                <tr key={event.id}>
                  <td>
                    <img src={event.posterUrl} alt={event.name} style={{ width: '100px', height: 'auto' }} />
                  </td>
                  <td>{event.name}</td>
                  <td>{event.location}</td>
                  <td>{event.date}</td>
                  <td>{event.time}</td>
                  <td>
                    <button 
                      className="btn btn-warning btn-sm me-2"
                      onClick={() => handleEdit(event)}
                    >
                      Edit
                    </button>
                    <button 
                      className="btn btn-danger btn-sm"
                      onClick={() => handleDelete(event.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Render the modal if an event is selected */}
      {selectedEvent && (
        <EditEventModal
          show={showModal}
          handleClose={handleCloseModal}
          event={selectedEvent}
          onEventUpdate={handleEventUpdated}
        />
      )}
    </div>
  );
};

export default ManageEvents;